import { ActionIcon, Box, Card, Group, Text, ThemeIcon, Tooltip } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { ReactElement, ReactNode } from 'react';
import { ACTIVITY_CATEGORY_COLORS } from '@/components/Timeline/activityCategories';

interface BillingComposerCardProps {
  /** The glyph in the billing-teal marker: the credit card, or the request's cross. */
  icon: ReactNode;
  title: string;
  onClose: () => void;
  /** While a write is in flight, the box stays: closing it would drop the write's follow-ups. */
  closeDisabled?: boolean;
  children: ReactNode;
  'data-testid'?: string;
}

/**
 * The billing composers' card in the timeline's message box slot: Coverage activity (BAR-3075)
 * and the refund or cancellation request (BAR-3069). Billing-teal marker, title, close X.
 */
export function BillingComposerCard({
  icon,
  title,
  onClose,
  closeDisabled,
  children,
  'data-testid': testId,
}: BillingComposerCardProps): ReactElement {
  return (
    <Card withBorder padding={0} radius="lg" data-testid={testId}>
      <Box style={{ borderBottom: '1px solid var(--mantine-color-gray-2)' }}>
        <Group w="100%" p="xs" justify="space-between" align="center">
          <Group>
            <ThemeIcon variant="filled" radius="lg" size="lg" bg={ACTIVITY_CATEGORY_COLORS.billing}>
              {icon}
            </ThemeIcon>
            <Text variant="header" c={ACTIVITY_CATEGORY_COLORS.billing}>
              {title}
            </Text>
          </Group>
          <Tooltip label="Close" withArrow position="top-end" openDelay={500}>
            <ActionIcon variant="subtle" color="gray" aria-label="Close" onClick={onClose} disabled={closeDisabled}>
              <IconX size={16} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Box>
      {children}
    </Card>
  );
}
